/* global THREE */
import HopeConceptStone from '@/atoms/HopeConceptStone'
import HopeStoneTexture from '@/atoms/HopeStoneTexture'
import find from 'lodash/find'
import applyToonLighting from '@/utils/applyToonLighting'
// import anime from 'animejs'

export default class HopeCategoryStone extends THREE.Group {
  //
  constructor (config, material) {
    super()

    this.unexplodedStone = new HopeConceptStone(config, material, true)
    // this.unexplodedStone.setVisible(false)
    this.unexplodedStone.setVisible(true)
    this.add(this.unexplodedStone)

    this._explodedStones = []

    this._exploded = false
    this.config = config
    this.exploded = false
    this._debug = false
    this._rotate = true
    this._spacing = 0
    this._oscillate = true
  }

  setY (value) {
    this.unexplodedStone.position.y = this.unexplodedStone.elasticPosition.y = this.unexplodedStone.elasticPosition.value.y = value
  }

  getY () {
    return this.unexplodedStone.position.y
  }

  hasConcept (concept) {
    return find(this.config.concepts, {id: concept.id}) !== undefined
  }

  findConceptStoneByConcept (concept) {
    return find(this._explodedStones, {config: {id: concept.id}})
  }

  get explodedStones () {
    return this._explodedStones
  }

  get exploded () {
    return this._exploded
  }

  set exploded (value) {
    this._exploded = value
    // create exploded stones on demand
    if (this._exploded === true && this._explodedStones.length < this.config.concepts.length) {
      this.createExplodedStones()
    }

    this.unexplodedStone.setVisible(!value)

    for (let i = 0; i < this._explodedStones.length; i++) {
      this._explodedStones[i].setVisible(value)
      if (i === 0) {
        this._explodedStones[i].position.y = this._explodedStones[i].elasticPosition.y = this.unexplodedStone.position.y - 0.25
      } else {
        this._explodedStones[i].position.y = this._explodedStones[i].elasticPosition.y = this._explodedStones[i - 1].position.y + 0.25
      }
    }
  }

  createExplodedStones () {
    // add/update stones
    this.config.concepts.forEach(concept => {
      let existingStone = this.findConceptStoneByConcept(concept)
      if (!existingStone) {
        let stone = new HopeConceptStone(concept, new THREE.MeshToonMaterial({
          specular: new THREE.Color(0x000000),
          shininess: 0,
          map: new HopeStoneTexture(this.config.color, 1),
          transparent: false
        }))
        stone.material.onBeforeCompile = applyToonLighting
        if (this._explodedStones.length > 0) {
          stone.elasticPosition.y = stone.position.y = this._explodedStones[this._explodedStones.length - 1].position.y + 0.25
        } else {
          stone.elasticPosition.y = stone.position.y = this.unexplodedStone.y - 0.25
        }
        stone.debug = false
        stone.rotate = true
        stone.oscillate = true
        stone.activeCollisionLOD = this._activeCollisionLOD
        stone.setVisible(this._exploded)
        this.add(stone)
        this._explodedStones.push(stone)
      } else {
        existingStone.config = concept
      }
    })
  }

  get config () {
    return this._config
  }

  set config (value) {
    this._config = value
    // unexploded
    this.unexplodedStone.config = value

    // inverse loop for removing unused exploded stone
    for (let i = this._explodedStones.length - 1; i >= 0; i--) {
      let stone = this._explodedStones[i]
      if (!find(value.concepts, {id: stone.config.id})) {
        stone.destroy()
        this.remove(stone)
        this._explodedStones.splice(i, 1)
      }
    }
    // this.createExplodedStones()
  }

  get activeCollisionLOD () {
    return this._activeCollisionLOD
  }

  set activeCollisionLOD (value) {
    this._activeCollisionLOD = value
    this.unexplodedStone.activeCollisionLOD = value

    for (let i = 0; i < this._explodedStones.length; i++) {
      this._explodedStones[i].activeCollisionLOD = value
    }
  }

  get collisionMesh () {
    return this.unexplodedStone.collisionMesh
  }

  get debug () {
    return this._debug
  }

  set debug (value) {
    this._debug = value
    this.unexplodedStone.debug = value
    for (let i = 0; i < this._explodedStones.length; i++) {
      this._explodedStones[i].debug = value
    }
  }

  get rotate () {
    return this._rotate
  }

  set rotate (value) {
    this._rotate = value
    this.unexplodedStone.rotate = value
    for (let i = 0; i < this._explodedStones.length; i++) {
      this._explodedStones[i].rotate = value
    }
  }

  get spacing () {
    return this._spacing
  }

  set spacing (value) {
    this._spacing = value
    this.unexplodedStone.spacing = value
    for (let i = 0; i < this._explodedStones.length; i++) {
      this._explodedStones[i].spacing = value
    }
  }

  get oscillate () {
    return this._oscillate
  }

  set oscillate (value) {
    this._oscillate = value
    this.unexplodedStone.oscillate = value
    for (let i = 0; i < this._explodedStones.length; i++) {
      this._explodedStones[i].oscillate = value
    }
  }

  update (parent, delta) {
    if (!this.exploded) {
      this.unexplodedStone.update(parent, delta)
    } else {
      for (let i = 0; i < this._explodedStones.length; i++) {
        if (i === 0) {
          this._explodedStones[i].update(parent, delta)
        } else {
          this._explodedStones[i].update(this._explodedStones[i - 1], delta)
        }
      }
    }
  }

  get upperCollider () {
    if (this.exploded) {
      return this._explodedStones[this._explodedStones.length - 1]
    }
    return this.unexplodedStone
  }

  destroy () {
    this.unexplodedStone.destroy()
    this.remove(this.unexplodedStone)
    this.unexplodedStone = null
    for (let i = 0; i < this._explodedStones.length; i++) {
      this._explodedStones[i].destroy()
      this.remove(this._explodedStones[i])
    }
    this._explodedStones = []
  }
}



// WEBPACK FOOTER //
// ./src/atoms/HopeCategoryStone.js